import React from "react";
import Box from "../Box/Box";
import PropTypes from "prop-types";
import Notify from "../../services/Notify";
import Loading from "../Loading/Loading";
import {ControlLabel, FormGroup} from "react-bootstrap";
import DeviceService from "../../services/DeviceService";
import QRCode from "qrcode.react";
import FormButtons from "../Form/FormButtons";

class DeviceForm extends React.Component {

  service = new DeviceService();

  constructor(props) {
    super(props);
    this.state = {};
  }

  submitForm() {
    const entity = {
      friendlyName: this.friendlyName.value.trim(),
      version: 0
    };
    this.setState({loading: true, message: 'Salvando...'});
    this.service.save(entity).then(
        (data) => {
          this.setState({...this.state, loading: false, message: null, entity: data});
          Notify.success('Entidade salva');
        },
        (error) => {
          Notify.error('Falha ao salvar entidade:', error);
          this.setState({loading: false, entity, message: null});
        }
    );
  }

  render() {
    const {loading, entity, message} = this.state;
    if (loading) {
      return <Loading message={message}/>
    }
    if (message) {
      return <h2>{message}</h2>
    }

    if (entity) {
      const dataToQrCode = JSON.stringify({uuid: entity.uuid, name: entity.friendlyName});
      return (
          <div>
            Scanear este este código com o dispositivo
            <div className="text-center">
              <QRCode style={{width: '20%', height: '20%'}} value={dataToQrCode}/>
            </div>
          </div>);
    }

    return (
        <Box info>
          <form ref={form => (this.form = form)} onSubmit={event => {
            event.preventDefault();
            this.submitForm()
          }}>

            <FormGroup>
              <ControlLabel>Nome</ControlLabel>
              <input type="text" className="form-control" placeholder="Nome"
                     required
                     name="friendlyName"
                     ref={friendlyName => this.friendlyName = friendlyName}
              />
            </FormGroup>

            <FormButtons history={this.props.history}/>

          </form>
        </Box>);
  }
}

DeviceForm.propTypes = {
  match: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired
};

export default DeviceForm;



// WEBPACK FOOTER //
// ./src/component/Device/DeviceForm.js